import React from 'react';
import { Link } from 'react-router-dom';

import './NavLinks.css';

const NavLinks = (props) => {
	return (
		<div className='nav-links_items'>
			<ul className='main_menu_list_items'>
				<li className='main_menu_list_item'>
					<Link to='/' className='main_menu_list_item_link'>
						Home
					</Link>
				</li>
				<li className='main_menu_list_item'>
					<Link to='/ourstory' className='main_menu_list_item_link'>
						Our Story
					</Link>
				</li>
				<li className='main_menu_list_item'>
					<Link to='/contact' className='main_menu_list_item_link'>
						Contact
					</Link>
				</li>
			</ul>
		</div>
	);
};

export default NavLinks;
